import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ImpersonateOrganisationComponent } from './impersonate-organisation.component';

const routes: Routes = [{ path: '', component: ImpersonateOrganisationComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ImpersonateOrganisationRoutingModule {}

@NgModule({
  imports: [
    ImpersonateOrganisationRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ImpersonateOrganisationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ImpersonateOrganisationComponent],
})
export class ImpersonateOrganisationModule {}
